// Preset brand color palettes. Each key is the palette ID stored in Firestore.
// The "600" shade is the primary action color shown in UI pickers.
export const BRAND_PALETTES = {
  green: {
    label: "Forest",
    swatch: "#1a8a54",
    50:  "#f0faf4", 100: "#d9f2e3", 200: "#b3e5c8", 300: "#7dcfa6",
    400: "#45b37d", 500: "#25a065", 600: "#1a8a54", 700: "#177045",
    800: "#155938", 900: "#12492e", 950: "#092a1a",
    shadowRgb: "37,160,101",
  },
  purple: {
    label: "Violet",
    swatch: "#7c3aed",
    50:  "#f5f3ff", 100: "#ede9fe", 200: "#ddd6fe", 300: "#c4b5fd",
    400: "#a78bfa", 500: "#8b5cf6", 600: "#7c3aed", 700: "#6d28d9",
    800: "#5b21b6", 900: "#4c1d95", 950: "#2e1065",
    shadowRgb: "124,58,237",
  },
  blue: {
    label: "Ocean",
    swatch: "#2563eb",
    50:  "#eff6ff", 100: "#dbeafe", 200: "#bfdbfe", 300: "#93c5fd",
    400: "#60a5fa", 500: "#3b82f6", 600: "#2563eb", 700: "#1d4ed8",
    800: "#1e40af", 900: "#1e3a8a", 950: "#172554",
    shadowRgb: "37,99,235",
  },
  rose: {
    label: "Rose",
    swatch: "#e11d48",
    50:  "#fff1f2", 100: "#ffe4e6", 200: "#fecdd3", 300: "#fda4af",
    400: "#fb7185", 500: "#f43f5e", 600: "#e11d48", 700: "#be123c",
    800: "#9f1239", 900: "#881337", 950: "#4c0519",
    shadowRgb: "225,29,72",
  },
  orange: {
    label: "Ember",
    swatch: "#ea580c",
    50:  "#fff7ed", 100: "#ffedd5", 200: "#fed7aa", 300: "#fdba74",
    400: "#fb923c", 500: "#f97316", 600: "#ea580c", 700: "#c2410c",
    800: "#9a3412", 900: "#7c2d12", 950: "#431407",
    shadowRgb: "234,88,12",
  },
  teal: {
    label: "Teal",
    swatch: "#0d9488",
    50:  "#f0fdfa", 100: "#ccfbf1", 200: "#99f6e4", 300: "#5eead4",
    400: "#2dd4bf", 500: "#14b8a6", 600: "#0d9488", 700: "#0f766e",
    800: "#115e59", 900: "#134e4a", 950: "#042f2e",
    shadowRgb: "13,148,136",
  },
  slate: {
    label: "Midnight",
    swatch: "#334155",
    50:  "#f8fafc", 100: "#f1f5f9", 200: "#e2e8f0", 300: "#cbd5e1",
    400: "#94a3b8", 500: "#64748b", 600: "#475569", 700: "#334155",
    800: "#1e293b", 900: "#0f172a", 950: "#020617",
    shadowRgb: "51,65,85",
  },
  pink: {
    label: "Blush",
    swatch: "#db2777",
    50:  "#fdf2f8", 100: "#fce7f3", 200: "#fbcfe8", 300: "#f9a8d4",
    400: "#f472b6", 500: "#ec4899", 600: "#db2777", 700: "#be185d",
    800: "#9d174d", 900: "#831843", 950: "#500724",
    shadowRgb: "219,39,119",
  },
};

export const PALETTE_ORDER = ["green", "purple", "blue", "rose", "orange", "teal", "slate", "pink"];

export function applyBrandPalette(paletteKey) {
  const palette = BRAND_PALETTES[paletteKey] || BRAND_PALETTES.green;
  const root = document.documentElement;
  const shades = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950];
  shades.forEach(s => root.style.setProperty(`--brand-${s}`, palette[s]));
  root.style.setProperty("--brand-shadow-rgb", palette.shadowRgb);
}
